import {
  ADD_PRODUCT,
  DECREMENT,
  INCREMENT,
  RESTORE_QUANTITY,
} from "./actionTypes";

const nextTodoId = (products) => {
  const maxId = products.reduce(
    (maxId, product) => Math.max(product.id, maxId),
    -1
  );
  return maxId + 1;
};

const initialState = {
  products: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      action.payload["id"] = nextTodoId(state.products);
      return {
        ...state,
        products: [...state.products, action.payload],
      };

    case INCREMENT:
      return {
        ...state,
        products: state.products.map((item) => {
          if (item.id === action.payload) {
            return {
              ...item,
              quantity: item.quantity + 1,
            };
          } else {
            return item;
          }
        }),
      };

    case DECREMENT:
      return {
        ...state,
        products: state.products.map((item) => {
          if (item.id === action.payload) {
            return {
              ...item,
              quantity: item.quantity - 1,
            };
          } else {
            return item;
          }
        }),
      };

    case RESTORE_QUANTITY:
      return {
        ...state,
        products: state.products.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              quantity: item.quantity + action.payload.value,
            };
          } else {
            return item;
          }
        }),
      };

    default:
      return state;
  }
};

export default reducer;
